import { ConfirmModalConfig } from "@/models/ICommon"
import stores from "@/stores"
export function showDeleteModal(props: ConfirmModalConfig) {
  stores.CommonStore.setConfirmModalConfig({
    title: props.title ?? t("DeleteBlock"),
    message: props.message ?? `Are you sure you want to delete these blocks?`,
    onConfirm: props.onConfirm,
    onCancel: props.onCancel,
    extraPrimaryAction: props.extraPrimaryAction ?? {
      content: t("Delete"),
      destructive: true,
    },
    extraCancelAction: props.extraCancelAction ?? {
      content: t("Cancel"),
    },
  })
}
